module.exports = __webpack_public_path__ + "img/Bitmap-Copy-8.e495d54c.png";